/**
 * Brand identity — single point of change for all four values.
 *
 * Ported from `lib/constants/brand.ts`. Nothing else hardcodes the product name or an asset
 * path, so an identity change is an edit here plus swapping two files in `public/`.
 *
 * The infrastructure identifiers still carry the original `lensworthy` codename — the Firebase
 * project id, the Firebase app names, the Azure resource names. Those are deliberately a
 * separate decision from user-visible copy, since renaming them means recreating cloud
 * resources; it is tracked on its own in the README's "Before shipping" checklist.
 */

/** Header, sign-in card, landing and about pages, and the browser tab title. */
export const BRAND_NAME = "Wanderlight";

/** One-line descriptor, for the places with room for a strapline — not the header or tab. */
export const BRAND_TAGLINE = "Image-making beyond the camera.";

/** The header falls back to a wordmark if this fails to load, so a bad path degrades. */
export const BRAND_LOGO_SRC = "/brand/wanderlight-logo.svg";

/** The signature J+P motif. Falls back to a flat ink backdrop if missing, or for
 *  `prefers-reduced-motion` users. */
export const BACKGROUND_VIDEO_SRC = "/video/background-loop.mp4";
